import React, { useState, useEffect, useContext } from 'react';
import { Grid } from '@mui/material';

import axiosInstance from '../../api';
import { authContext } from '../../routes';
import SERVER_API_URL from '../../config';
import MiniWidgetSummary from './MiniWidgetSummary';

export default function MiniAppWidgetSummary() {
  const { user } = useContext(authContext);

  const [usersWhoHasConfessors, setUsersWhoHasConfessors] = useState();
  const [usersWhoHasNotConfessors, setUsersWhoHasNotConfessors] = useState();
  const [deletedUsers, setDeletedUsers] = useState();

  const dioceseLevel = user && user.role.permissions.dioceseLevel.read;
  const districtLevel = user && user.role.permissions.districtLevel.read;
  const churchLevel = user && user.role.permissions.churchLevel.read;

  useEffect(() => {
    const getUsersWithConfessors = async () => {
      try {
        let response;
        if (dioceseLevel) {
          response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/usersWhoHasConfessors`);
        } else if (districtLevel) {
          response = await axiosInstance.post(
            `${SERVER_API_URL}/dashboard/usersWhoHasConfessorsByDistrictId/${user && user.church.district.id}`
          );
        } else {
          response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/usersWhoHasConfessorsByChurchId/${user && user.church.id}`);
        }
        if (response.status === 200) {
          setUsersWhoHasConfessors(response.data.length);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    const getUsersWithNotConfessors = async () => {
      try {
        let response;
        if (dioceseLevel) {
          response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/usersWhoHasNotConfessors`);
        } else if (districtLevel) {
          response = await axiosInstance.post(
            `${SERVER_API_URL}/dashboard/usersWhoHasNotConfessorsByDistrictId/${user && user.church.district.id}`
          );
        } else {
          response = await axiosInstance.post(`${SERVER_API_URL}/dashboard/usersWhoHasNotConfessorsByChurchId/${user && user.church.id}`);
        }
        if (response.status === 200) {
          setUsersWhoHasNotConfessors(response.data.length);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    const getDeletedUsers = async () => {
      try {
        let response;
        if (dioceseLevel) {
          response = await axiosInstance.post(`${SERVER_API_URL}/user/findAllDeletedForDashboard`);
        } else if (districtLevel) {
          response = await axiosInstance.post(
            `${SERVER_API_URL}/user/findManyDeletedByDistrictId/${user && user.church.district.id}`
          );
        } else {
          response = await axiosInstance.post(`${SERVER_API_URL}/user/findManyDeletedByChurchId/${user && user.church.id}`);
        }
        if (response.status === 200) {
          setDeletedUsers(response.data.length);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    getDeletedUsers();
    getUsersWithNotConfessors();
    getUsersWithConfessors();
  }, [dioceseLevel, districtLevel, user]);

  return (
    <Grid container spacing={3}>
      {churchLevel && (
        <>
          <Grid item xs={12} sm={12} md={4}>
            <MiniWidgetSummary
              title="የንስሃ አባት ያላቸው"
              subheader="የንስሃ አባት ያላቸው ተካታዮች"
              total={usersWhoHasConfessors}
              color="success"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <MiniWidgetSummary
              title="ንስሃ አባት የሚያስፈልጋቸው"
              subheader="የንስሃ አባት የሌላቸው ተካታዮች"
              total={usersWhoHasNotConfessors}
              color="warning"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <MiniWidgetSummary
              title="የተሰረዙ ተከታዮች"
              subheader="የተሰረዙ ተከታዮችም ከሁሉም ምድቦች"
              total={deletedUsers}
              color="error"
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
